/* eslint-disable react/jsx-curly-newline */
import React from 'react';
// @ts-ignore
import { Button } from '@els/els-react--button';
// @ts-ignore
import { SingleSelect } from '@els/els-react--select';
// @ts-ignore
import { Icon } from '@els/els-react--icon';
import {
    languageCode,
    LanguageCodeType,
    languageLabels,
} from '../../constants/language-codes';

interface BannerLinksProps {
    handlePrintClick: (data: boolean) => void;
    onSelectLanguage: (language: LanguageCodeType) => void;
    currentLanguage: LanguageCodeType;
    handleEmail: (data: boolean) => void;
    handleCopyLink: () => void;
    isUserAuthenticated: boolean;
    copyLinkToast?: React.ReactNode;
    copyLinkButtonRef?: React.RefObject<HTMLButtonElement> | null;
}

export const BannerLinks = ({
    handlePrintClick,
    onSelectLanguage,
    currentLanguage,
    handleEmail,
    handleCopyLink,
    isUserAuthenticated,
    copyLinkToast = null,
    copyLinkButtonRef = null,
}: BannerLinksProps) => {
    const baseClassName = 'banner-links';
    const alternativeLanguage =
        currentLanguage === languageCode.ENGLISH
            ? languageCode.SPANISH
            : languageCode.ENGLISH;

    const printLabel =
        currentLanguage === languageCode.ENGLISH
            ? 'Print content in English'
            : 'Print content in Spanish';

    const languageOptions = [
        {
            label: languageLabels[alternativeLanguage],
            value: alternativeLanguage,
        },
    ];

    const handleLanguageSelect = (option: { label: string; value: string }) => {
        if (option.value === alternativeLanguage) {
            onSelectLanguage(alternativeLanguage);
        }
    };

    return (
        <div
            className={`${baseClassName} o-els-flex-layout__item o-els-flex-layout__item--grow`}
            role="group"
            aria-label="Content actions"
        >
            <Button
                ref={copyLinkButtonRef}
                size="x-small"
                type="link"
                className={`${baseClassName}__button`}
                onClick={handleCopyLink}
                aria-label="Copy Link"
            >
                <Icon
                    sprite="DuplicateDocument"
                    size="xs"
                    className="button-icon"
                    isDecorative
                />
                <span className="button-text">Copy link</span>
            </Button>
            {copyLinkToast}
            {isUserAuthenticated && (
                <Button
                    size="x-small"
                    type="link"
                    onClick={handleEmail}
                    className={`${baseClassName}__button`}
                    aria-label="Email content"
                >
                    <Icon
                        sprite={Icon.Sprites.EMAIL}
                        size="xs"
                        className="button-icon"
                        isDecorative
                    />
                    <span className="button-text">Email</span>
                </Button>
            )}
            <div
                aria-label="Change language"
                className={`${baseClassName}__language-button`}
            >
                <Icon
                    sprite="Globe"
                    size="xs"
                    className="button-icon"
                    isDecorative
                    color="secondary"
                    style={{ marginRight: '1rem' }}
                />
                <SingleSelect
                    key={currentLanguage}
                    id="banner-language"
                    options={languageOptions}
                    selectedOptions={[]}
                    label="Select Language"
                    onSelect={handleLanguageSelect}
                    isPlainInput
                    placeholderText={languageLabels[currentLanguage]}
                    required
                    hideRequired
                    shouldHideLabel
                    shouldSelectionWrap
                    shouldCloseOnESC
                    className={`${baseClassName}__language-select`}
                />
            </div>
            <Button
                size="x-small"
                type="link"
                className={`${baseClassName}__print-button`}
                onClick={handlePrintClick}
                aria-label={printLabel}
            >
                <Icon
                    sprite="Printer"
                    size="xs"
                    className="print-button-icon"
                    isDecorative
                />
                <span className="print-btn-text">Print</span>
            </Button>
        </div>
    );
};

BannerLinks.defaultProps = {
    copyLinkToast: null,
    copyLinkButtonRef: null,
};
